export default __webpack_public_path__ + "static/checkout-code-snippet-eba28fbd8451735d4b89b25f57864d9a.png";